(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_dome-2-airfryer-main"] && !Shopify.designMode) return;
  try {
    
  const pageWrapper = document.querySelector(".phone-section__page-wrapper")
  let isDragging = false
  let dragStartX
  let scroll

  const startDragging = (e) => {
    e.preventDefault()
    pageWrapper.style.scrollSnapType = "none"
    isDragging = true
    dragStartX = e.pageX - pageWrapper.offsetLeft
    scroll = pageWrapper.scrollLeft
  }

  const stopDragging = (e) => {
    pageWrapper.style.scrollSnapType = "x mandatory"
    isDragging = false
    
  }

  const drag = (e) => {
    if (isDragging) {
      const x = e.pageX - pageWrapper.offsetLeft
      const delta = x - dragStartX
      window.requestAnimationFrame(() => pageWrapper.scrollLeft = (scroll - delta))
    }
  }

  pageWrapper.addEventListener('mousedown', startDragging)
  pageWrapper.addEventListener('mouseup', stopDragging)
  pageWrapper.addEventListener('mousemove', drag)
  pageWrapper.addEventListener('mouseout', stopDragging)


  } catch(e) { console.error(e); }
})();
})();
